<script lang="ts" >
    import OutlineButton from "../../common/outline-button.component.svelte";
    export let selected = false;
    export let className = "primary"
</script>

<OutlineButton on:click  className={className} reverse={selected} > <slot> </slot></OutlineButton>

